import type { InfinexErrorType } from '@infinex-private/connect-types';
import { getInfinexError } from '@infinex-private/connect-utils';

// User-facing copy for typed signing denials that cannot succeed on retry.
// Without a mapping the popup renders the raw serialized error blob.
const DENIAL_COPY: Partial<Record<InfinexErrorType, string>> = {
  DAPP_SIGNING_DISABLED:
    'This wallet is blocked from dapp signing in Security settings. Unblock it under Settings → Security to sign with it.',
  SIGNING_POLICY_DENIED:
    'Your account needs a security update before it can sign. Retrying will not work until your signing policies are upgraded.',
};

export function denyMessageFor(err: unknown): string | null {
  const type = getInfinexError(err)?.type;
  return type ? (DENIAL_COPY[type] ?? null) : null;
}
